import { makeStyles, Theme } from '@material-ui/core/styles';
import { PRIMARY } from '@/theme/typography';
import { PrimaryColors } from '@/utils/constants';

const useContentCardStyles = makeStyles(
  (muiTheme: Theme) => ({
    root: {
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginBottom: '5px',
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    image: {
      height: '130px !important',
    },
    cardContent: {
      backgroundColor: PrimaryColors.main,
      padding: `${muiTheme.spacing(3, 3)} !important`,
      fontSize: '15px',
      lineHeight: '26px',
      textAlign: 'left',
      flex: 1,
      '& div.rich-text': {
        transition: 'color 0.3s ease',
      },
    },
    contentCategory: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
        zIndex: 1,
        position: 'relative',
        textAlign: 'left',
        color: '#BDBDBD',
        fontSize: '10px',
      },
    },
    contentDescription: {
      '& *': {
        ...PRIMARY,
      },
      '& p': {
        ...muiTheme.typography.body1,
      },
    },
  }),
  { name: 'PortalCarouselContentCard' },
);

export default useContentCardStyles;
